export enum ProfileTypeEnum {
    EMPLOYEE = 'Employee',
    DEALER = 'Dealer',
}